/* ══════════════════════════════════════════════════════════════════════════
   AURORA · front-end behaviours for the Shopify build

   Every block guards on the elements it needs, so a section that is not on
   the page costs nothing and never throws. Loaded once from theme.liquid with
   `defer`, so it runs after the markup is parsed.
   ══════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── sticky header ──────────────────────────────────────────────────── */
  var hdr = document.getElementById('hdr');
  if (hdr) {
    addEventListener('scroll', function () {
      hdr.classList.toggle('stuck', scrollY > 10);
    }, { passive: true });
  }

  /* ── mobile menu: the panel is the same .navlinks list, shown by a class ─
     No scroll lock on <body>: Shopify renders the header inside a section
     wrapper that carries position:sticky, and setting overflow:hidden on the
     body turns it into a scroll container, which takes the wrapper out of the
     sticky context. Scrolled down, the header vanished the moment the panel
     opened. The panel caps its own height and contains its overscroll, so the
     page behind it barely moves anyway. ──────────────────────────────────── */
  var mb = document.getElementById('menuBtn');
  if (mb && hdr) {
    var closeNav = function () {
      hdr.classList.remove('nav-open');
      mb.setAttribute('aria-expanded', 'false');
    };
    mb.addEventListener('click', function () {
      var open = hdr.classList.toggle('nav-open');
      mb.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    /* tapping outside the panel closes it, since nothing dims the page */
    document.addEventListener('click', function (e) {
      if (!hdr.classList.contains('nav-open')) return;
      if (e.target.closest('#navLinks') || e.target.closest('#menuBtn')) return;
      closeNav();
    });
    addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });
    document.querySelectorAll('#navLinks a').forEach(function (a) {
      a.addEventListener('click', closeNav);
    });
    /* 1180px is where aurora.css hands the links back to the row */
    addEventListener('resize', function () { if (innerWidth > 1180) closeNav(); });
  }

  /* ── Products dropdown ─────────────────────────────────────────────────
     CSS already opens the menu on :hover and :focus-within, so this is only
     the click behaviour and the aria-expanded bookkeeping. Below 1180px the
     menu is a plain indented list inside the hamburger panel, so the toggle
     stands down and leaves it alone. ─────────────────────────────────────── */
  (function () {
    var PANEL = '(max-width:1180px)';
    var drops = [].slice.call(document.querySelectorAll('.navdrop'));
    if (!drops.length) return;

    var inPanel = function () { return matchMedia(PANEL).matches; };
    var set = function (drop, open) {
      var btn = drop.querySelector('.navdrop-btn');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    };
    var closeAll = function (except) {
      drops.forEach(function (d) { if (d !== except) set(d, false); });
    };

    drops.forEach(function (drop) {
      var btn = drop.querySelector('.navdrop-btn');
      if (!btn) return;

      btn.addEventListener('click', function (e) {
        if (inPanel()) return;          /* the list is already open in the panel */
        e.preventDefault();
        var open = btn.getAttribute('aria-expanded') !== 'true';
        closeAll(drop);
        set(drop, open);
      });
      /* a pointer leaving the group drops the click-open state too, or the
         menu stays pinned open after the cursor has moved away */
      drop.addEventListener('mouseleave', function () { if (!inPanel()) set(drop, false); });
      drop.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { set(drop, false); btn.focus(); }
      });
      drop.addEventListener('focusout', function (e) {
        if (!drop.contains(e.relatedTarget)) set(drop, false);
      });
      drop.querySelectorAll('.navdrop-menu a').forEach(function (a) {
        a.addEventListener('click', function () { set(drop, false); });
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.navdrop')) closeAll(null);
    });
    addEventListener('resize', function () { if (inPanel()) closeAll(null); });
  })();

  /* ── the live hero stage sits between the H1 and the lede on phones ───── */
  (function () {
    var stage = document.querySelector('.hero .stage');
    var slot = document.getElementById('heroVizSlot');
    if (!stage || !slot) return;
    var home = stage.parentElement;
    var mq = matchMedia('(max-width:1080px)');
    var place = function () {
      var target = mq.matches ? slot : home;
      if (stage.parentElement !== target) target.appendChild(stage);
    };
    place();
    mq.addEventListener('change', place);
  })();

  /* ── reveal + count-up ─────────────────────────────────────────────────
     Content is visible in CSS; JS only hides what starts below the fold, and
     three separate paths can un-hide it again, so a missed trigger costs the
     animation and never the content. ─────────────────────────────────────── */
  (function () {
    var els = [].slice.call(document.querySelectorAll('[data-reveal]'));
    var below = reduced ? [] : els.filter(function (el) {
      return el.getBoundingClientRect().top > innerHeight * 0.92;
    });
    below.forEach(function (el, i) {
      el.classList.add('pre');
      el.style.transitionDelay = (i % 4) * 60 + 'ms';
    });

    var show = function (el) { el.classList.remove('pre'); };
    var sweep = function () {
      below.forEach(function (el) {
        if (el.classList.contains('pre') &&
            el.getBoundingClientRect().top < innerHeight * 0.92) show(el);
      });
    };

    if ('IntersectionObserver' in window && !reduced) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (en.isIntersecting) { show(en.target); io.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
      below.forEach(function (el) { io.observe(el); });
    }
    addEventListener('scroll', sweep, { passive: true });
    addEventListener('resize', sweep);
    setTimeout(sweep, 800);
    setTimeout(function () { below.forEach(show); }, 3000);

    /* count-up: the final value is already in the DOM, so a missed trigger
       costs the animation, never the number */
    var nums = [].slice.call(document.querySelectorAll('[data-count]'));
    if (!reduced && 'IntersectionObserver' in window && nums.length) {
      var nio = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          var el = en.target, to = +el.dataset.count, t0 = performance.now(), dur = 1100;
          var step = function (t) {
            var k = Math.min((t - t0) / dur, 1);
            el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3)));
            if (k < 1) requestAnimationFrame(step); else el.textContent = to;
          };
          requestAnimationFrame(step);
          nio.unobserve(el);
        });
      }, { threshold: 0.5 });
      nums.forEach(function (n) { nio.observe(n); });
    }
  })();

  /* ── hero slider ───────────────────────────────────────────────────────
     One slide per product. The copy, the pack shot on the stage, the caption
     and the shop button all move together, so the hero carries the whole
     range instead of leading on one product. Pauses whenever the tab is
     hidden or the visitor is pointing at the card. ───────────────────────── */
  (function () {
    var slides = [].slice.call(document.querySelectorAll('.hslide'));
    var dots = [].slice.call(document.querySelectorAll('.hdot'));
    if (slides.length < 2) return;
    var shots = [].slice.call(document.querySelectorAll('.stage-shot'));
    var wrap = document.getElementById('heroStageWrap');
    var has3d = !!document.getElementById('heroStage');
    var tag = document.getElementById('heroTag');
    var shop = document.getElementById('heroShop');
    var i = 0, timer = null, PAUSE = 6000;

    function show(n) {
      i = (n + slides.length) % slides.length;
      slides.forEach(function (s, x) { s.classList.toggle('on', x === i); });
      dots.forEach(function (d, x) {
        d.classList.toggle('on', x === i);
        d.setAttribute('aria-selected', x === i);
      });

      var s = slides[i], k = s.getAttribute('data-shot');
      shots.forEach(function (img) {
        img.classList.toggle('on', img.getAttribute('data-k') === k);
      });
      /* "3d" is the turning stage; every other key is a flat pack shot, and
         shot-mode fades the canvas out from under them */
      if (wrap && has3d) wrap.classList.toggle('shot-mode', k !== '3d');
      if (tag) {
        var name = tag.querySelector('.st-name');
        if (name) name.textContent = s.getAttribute('data-tag');
        /* the drag hint belongs to the model only — and the CSS hides it
           anyway until the viewer reports data-3d="ready" */
        tag.classList.toggle('no-drag', !has3d || k !== '3d');
      }
      if (shop) {
        shop.textContent = s.getAttribute('data-cta');
        shop.setAttribute('href', s.getAttribute('data-href'));
      }
    }
    function play() { if (reduced) return; stop(); timer = setInterval(function () { show(i + 1); }, PAUSE); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    dots.forEach(function (d, x) {
      d.addEventListener('click', function () { show(x); play(); });
    });
    var card = document.querySelector('.hero-card');
    if (card) {
      card.addEventListener('mouseenter', stop);
      card.addEventListener('mouseleave', play);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) { stop(); } else { play(); }
    });
    show(0);
    play();
  })();

  /* ── the range: first row, then a button ───────────────────────────────
     The grid renders every card, and this holds back everything past the
     first row — so with the script gone the whole range simply shows, which
     is the safe way for it to fail. How many cards a row holds changes with
     the breakpoint, so the count is measured rather than fixed at four,
     which would strand one card alone on a second row at tablet sizes. ──── */
  (function () {
    var grid = document.querySelector('[data-range-cap]');
    if (!grid) return;
    var cards = [].slice.call(grid.children);
    if (cards.length < 2) return;

    var label = grid.getAttribute('data-range-cap') || 'Explore More Solutions';
    var expanded = false, btn = null;

    function firstRowCount() {
      cards.forEach(function (c) { c.hidden = false; });
      var top = cards[0].offsetTop, n = 0;
      for (var i = 0; i < cards.length; i++) {
        if (cards[i].offsetTop !== top) break;
        n++;
      }
      /* below 760px the grid is a swipe rail on one flex line, where every
         card reports the same offset — the cap keeps that from revealing
         the lot */
      return Math.min(n || 4, 4);
    }
    function collapse() {
      var n = firstRowCount();
      cards.forEach(function (c, i) { c.hidden = i >= n; });
      if (btn) btn.hidden = cards.length - n < 1;
    }

    collapse();
    if (!cards.some(function (c) { return c.hidden; })) return;

    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'btn btn-ghost prow-toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.textContent = label;
    btn.addEventListener('click', function () {
      expanded = true;
      cards.forEach(function (c) { c.hidden = false; });
      btn.remove();
      btn = null;
    });
    grid.after(btn);

    /* a rotation or a resized window changes the column count under it */
    var t = null;
    addEventListener('resize', function () {
      if (expanded) return;
      clearTimeout(t);
      t = setTimeout(collapse, 150);
    });
  })();

  /* ── review carousel: card-by-card slider, autoplay pauses on touch ───── */
  (function () {
    var track = document.getElementById('ugcTrack');
    if (!track) return;
    var prev = document.getElementById('ugcPrev'),
        next = document.getElementById('ugcNext'),
        dots = document.getElementById('ugcDots');
    if (!prev || !next || !dots) return;

    function step() {
      var c = track.querySelector('.ugc');
      var gap = parseFloat(getComputedStyle(track).columnGap) || 20;
      return c ? c.getBoundingClientRect().width + gap : track.clientWidth;
    }
    function pages() { return Math.max(1, Math.ceil((track.scrollWidth - track.clientWidth) / step()) + 1); }
    function idx() { return Math.round(track.scrollLeft / step()); }
    function atEnd() { return track.scrollLeft >= track.scrollWidth - track.clientWidth - 2; }
    function build() {
      var n = pages();
      if (dots.children.length === n) return;
      dots.textContent = '';
      for (var i = 0; i < n; i++) {
        (function (i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.setAttribute('aria-label', 'Go to review ' + (i + 1));
          b.addEventListener('click', function () { track.scrollTo({ left: i * step() }); });
          dots.appendChild(b);
        })(i);
      }
    }
    function sync() {
      var i = idx();
      [].forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === i); });
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = atEnd();
      dots.style.display = pages() > 1 ? 'flex' : 'none';
    }
    prev.addEventListener('click', function () { track.scrollBy({ left: -step() }); });
    next.addEventListener('click', function () { track.scrollBy({ left: step() }); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    }, { passive: true });
    addEventListener('resize', function () { build(); sync(); });
    build(); sync();

    /* Continuous auto-scroll. Stepping a whole card every 4.2s left only
       ~235px of scrollable range against a ~340px step with five reviews, so
       it jumped to the end and snapped back, reading as a glitch rather than
       a scroll. Duplicating the set gives it somewhere to go, and a constant
       drift loops seamlessly at the halfway mark. */
    var cards = [].slice.call(track.querySelectorAll('.ugc'));
    var half = 0, raf2 = null, last = 0, paused = false, pos = 0;
    var SPEED = 28;  /* px per second — slow enough to read a card while it moves */

    function cloneSet() {
      if (reduced || track.dataset.looped) return;
      cards.forEach(function (c) {
        var k = c.cloneNode(true);
        k.setAttribute('aria-hidden', 'true');
        k.querySelectorAll('a,button').forEach(function (el) { el.tabIndex = -1; });
        track.appendChild(k);
      });
      track.dataset.looped = '1';
      half = track.scrollWidth / 2;
    }
    function tick(ts) {
      if (!last) last = ts;
      var dt = (ts - last) / 1000; last = ts;
      if (!paused && half > 0) {
        /* accumulate in a float and assign: `scrollLeft += 0.45` loses the
           fraction every frame, because scrollLeft reads back rounded, and
           the rail never actually moves */
        pos += SPEED * dt;
        if (pos >= half) pos -= half;
        track.scrollLeft = pos;
      }
      raf2 = requestAnimationFrame(tick);
    }
    function startLoop() {
      if (reduced || raf2) return;
      cloneSet();
      if (half <= 0) return;
      last = 0; raf2 = requestAnimationFrame(tick);
    }
    function pause() { paused = true; }
    function resume() { paused = false; last = 0; }

    ['pointerenter', 'focusin', 'pointerdown'].forEach(function (e) { track.addEventListener(e, pause); });
    ['pointerleave', 'focusout'].forEach(function (e) { track.addEventListener(e, resume); });
    /* the manual arrows still work; nudge past the seam if they run off the end */
    prev.addEventListener('click', function () { if (half && track.scrollLeft < 2) track.scrollLeft = half; });

    /* only run while the section is on screen */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          /* resume() as well as startLoop(): the observer fires once on setup
             while the rail is still below the fold, which sets paused, and
             startLoop alone never cleared it — the loop built its clones and
             then sat frozen */
          if (e.isIntersecting) { startLoop(); resume(); } else { pause(); }
        });
      }, { threshold: .15 }).observe(track);
    } else { startLoop(); resume(); }
  })();

  /* ── product gallery: thumbs swap the main shot ───────────────────────── */
  (function () {
    var main = document.getElementById('gmain');
    var thumbs = [].slice.call(document.querySelectorAll('.gallery-thumbs button'));
    if (!main || !thumbs.length) return;
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var src = b.getAttribute('data-src');
        if (!src) return;
        main.src = src;
        thumbs.forEach(function (o) { o.classList.toggle('on', o === b); });
      });
    });
  })();

  /* ── variant pills: keep the price in step with the chosen size ───────── */
  (function () {
    var wrap = document.querySelector('.pdp-variants');
    var price = document.getElementById('pdpPrice');
    if (!wrap) return;
    wrap.addEventListener('change', function (e) {
      var input = e.target.closest('input[name="id"]');
      if (!input) return;
      [].forEach.call(wrap.querySelectorAll('.pdp-variant'), function (l) {
        l.classList.toggle('on', l.contains(input));
      });
      if (price && input.dataset.price) price.textContent = input.dataset.price;
    });
  })();

  /* ── add to cart ───────────────────────────────────────────────────────
     The product cards post a real variant id to /cart/add.js, so the button
     behaves as it did in the mockup while the cart is Shopify's. Cards with
     no product linked yet carry no [data-variant] and stay plain links. ──── */
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function paintCount(n) {
    document.querySelectorAll('.cart-dot').forEach(function (d) {
      d.textContent = n;
      d.hidden = n < 1;
    });
    /* let Sense's own cart drawer refresh itself if it is still installed */
    document.dispatchEvent(new CustomEvent('aurora:cart:updated', { detail: { count: n } }));
  }

  function refreshCount() {
    fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { paintCount(c.item_count); })
      .catch(function () { /* leave the bubble as rendered */ });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-variant]');
    if (!b) return;
    e.preventDefault();
    if (b.disabled) return;

    var label = b.textContent;
    b.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(b.dataset.variant), quantity: 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function () {
        b.textContent = 'Added';
        b.classList.add('added');
        refreshCount();
      })
      .catch(function () {
        b.textContent = 'Try again';
      })
      .then(function () {
        setTimeout(function () {
          b.textContent = label;
          b.classList.remove('added');
          b.disabled = false;
        }, 1400);
      });
  });
})();
